import anime from 'animejs'
import css from '@emotion/css'
import classNames from 'classnames'
import React, { Component } from 'react'

import { FS_L, mq } from '../css/style'
import In from './in'

class Name extends Component {
    state = {
        isNameVisible: false,
        isImageVisible: false,
        x: 50,
        y: 50,
    }

    containerRef = React.createRef()
    imgRef = React.createRef()
    maskedRef = React.createRef()
    nameRef = React.createRef()

    componentDidMount() {
        this.currentX = this.currentY = this.newPosX = this.newPosY = 0
        this.scale = 0.8

        this.timer = null
        this.beingOff = false

        this.handleRaf()
        window.addEventListener('mousemove', this.handleWindowMouse)
    }

    getTransform = el => {
        const style = window.getComputedStyle(el).getPropertyValue('transform')

        let values = style.split('(')[1]
        values = values.split(')')[0]
        values = values.split(',')

        return values.map(el => {
            return parseInt(el, 10)
        })
    }

    handleWindowMouse = event => {
        this.x = event.clientX
        this.y = event.clientY
        this.currentScroll = document.documentElement.scrollTop
    }

    checkHover = () => {
        // return this.y
        return (
            Math.abs(this.currentScroll - document.documentElement.scrollTop) <
            window.innerWidth / 6
        )
        // return (
        //     this.nameRef.current.parentElement.querySelector(':hover') ===
        //     this.nameRef.current
        // )
    }

    handleRaf = () => {
        requestAnimationFrame(this.handleRaf)

        if (!this.isActive) return
        if (!this.checkHover() && !this.beingOff) this.handleMouseLeave()

        this.currentX += (this.newPosX - this.currentX) * 0.1
        this.currentY += (this.newPosY - this.currentY) * 0.1

        this.setImgPos()

        if (this.state.isImageVisible) this.setImgMask()
    }

    setImgPos = () => {
        this.imgRef.current.style.transform = `translateX(-50%) translateX(${
            this.currentX
        }px) translateY(-50%) translateY(${this.currentY}px) scale(${
            this.scale
        })`
    }

    setImgMask = () => {
        const nameViewportOffset = this.nameRef.current.getBoundingClientRect()
        const topPosName = nameViewportOffset.top
        const leftPosName = nameViewportOffset.left
        const nameWidth = nameViewportOffset.width
        const nameHeight = nameViewportOffset.height

        const pictureViewportOffset = this.imgRef.current.getBoundingClientRect()
        const topPosPicture = pictureViewportOffset.top
        const leftPosPicture = pictureViewportOffset.left
        const pictureWidth = pictureViewportOffset.width
        const pictureHeight = pictureViewportOffset.height

        const xOverName = nameWidth - pictureWidth
        const leftSpace = leftPosPicture - leftPosName
        const yOverName = nameHeight - pictureHeight
        const topSpace = topPosPicture - topPosName

        let $masked

        if (this.nameRef.current.classList.contains('masked')) {
            $masked = this.nameRef.current
        } else {
            $masked = this.maskedRef.current
        }

        $masked.style.clipPath = $masked.style.webkitClipPath = `inset(${topSpace}px ${xOverName -
            leftSpace}px ${yOverName - topSpace}px ${leftSpace}px)`
    }

    handleMouseEnter = () => {
        if (!this.props.isDesktop) return

        clearTimeout(this.timer)
        this.isActive = true
        this.currentScroll = document.documentElement.scrollTop

        this.objAnime = {
            scale: 0.8,
        }

        this.handleMouseMove()
        this.currentX = this.newPosX
        this.currentY = this.newPosY
        this.setImgPos()
        // this.currentX = this.x
        // this.currentY = this.y

        anime({
            targets: this.objAnime,
            scale: 1,
            duration: 600,
            easing: 'easeOutExpo',
            begin: () => {
                this.setState({ isImageVisible: true })
            },
            update: () => {
                this.scale = this.objAnime.scale
            },
        })
    }

    handleMouseLeave = () => {
        if (!this.isActive) return

        this.beingOff = true

        anime.remove(this.objAnime)

        this.setState({ isImageVisible: false })

        this.timer = setTimeout(() => {
            this.isActive = false
            this.beingOff = false

            let $masked

            if (this.imgRef.current.classList.contains('masked')) {
                $masked = this.imgRef.current
            } else {
                $masked = this.maskedRef.current
            }

            $masked.style.clipPath = $masked.style.webkitClipPath =
                'inset(0px 100% 0px 0px)'
        }, 200)
    }

    handleMouseMove = () => {
        if (!this.isActive) return

        const percentToPxX = (this.state.x / 100) * window.innerWidth
        const percentToPxY = (this.state.y / 100) * window.innerHeight

        const distanceX = percentToPxX - this.x
        const distanceY = percentToPxY - this.y

        const sideX = this.x < percentToPxX ? -1 : 1
        const sideY = this.y < percentToPxY ? -1 : 1

        const newX = Math.abs(distanceX) * sideX * 0.25
        const newY = Math.abs(distanceY) * sideY * 0.25

        // if (!this.currentX && this.currentX !== 0) {
        // this.currentX = newX
        // this.currentY = newY
        // }

        this.newPosX = newX
        this.newPosY = newY
    }

    handleNameIn = () => {
        this.setState({ isNameVisible: true })
        anime({
            targets: this.nameRef.current,
            translateX: [
                this.props.isRight
                    ? `${window.innerWidth * 0}px`
                    : `${-window.innerWidth * 0}px`,
                `${this.props.decal}%`,
            ],
            scaleX: [1.2, 1],
            easing: 'easeOutExpo',
            duration: 1000,
        })
    }

    render() {
        const { song, name, img } = this.props

        return (
            <div css={nameContainer} ref={this.containerRef}>
                <img
                    src={img}
                    css={imgClassFn({ x: this.state.x, y: this.state.y })}
                    alt={nameClassFn({ decal: this.props.decal })}
                    className={classNames({
                        'is-visible': this.state.isImageVisible,
                    })}
                    ref={this.imgRef}
                />
                <p
                    css={[
                        songClass,
                        songDecalFn({ decalTitle: this.props.decalTitle }),
                    ]}
                    className={classNames({
                        'is-hover': this.state.isImageVisible,
                    })}
                >
                    {song}
                </p>
                <In cb={this.handleNameIn}>
                    <h2
                        css={nameClassFn({
                            decal: this.props.decal,
                            decal2: this.props.decal2,
                            isImageVisible: this.state.isImageVisible,
                        })}
                        className={classNames({
                            'is-visible': this.state.isNameVisible,
                        })}
                        ref={this.nameRef}
                        onMouseEnter={this.handleMouseEnter}
                        onMouseLeave={this.handleMouseLeave}
                        onMouseMove={this.handleMouseMove}
                    >
                        {name || this.props.children}
                        <div
                            className={classNames('masked', {
                                'is-visible': this.state.isImageVisible,
                            })}
                            ref={this.maskedRef}
                            css={[
                                nameClassFn({
                                    decal: this.props.decal,
                                    decal2: this.props.decal2,
                                }),
                                masked,
                            ]}
                        >
                            {name || this.props.children}
                        </div>
                    </h2>
                </In>
            </div>
        )
    }
}

const nameContainer = css`
    position: relative;
    text-align: center;
`

export const songClass = css`
    color: black;
    font-family: 'Avenir';
    font-size: ${FS_L};
    font-weight: 800;
    line-height: 0.9;
    margin: 1.5em 0 0.5em;
    position: relative;
    text-transform: uppercase;
    transition: color 0.2s linear;
    user-select: none;

    ${mq.small(css`
        margin: 2em 0;
    `)};

    &.is-hover {
        color: #6e46b6;
    }
`

const songDecalFn = (props = {}) => css`
    transform: translateX(${props.decalTitle}%);
`

const nameClassFn = (props = {}) => css`
    display: inline-block;
    font-family: 'Avenir';
    font-size: 18vw;
    font-weight: 800;
    line-height: 0.8;
    margin: 0;
    opacity: 0;
    padding-right: 0.1em;
    position: relative;
    text-transform: uppercase;
    /* transform: translateX(${props.decal || 0}%); */
    transition: opacity 0.7s linear;
    user-select: none;
    will-change: transform, opacity;
    z-index: ${props.isImageVisible ? 2 : 0};
    -webkit-text-fill-color: transparent;
    -webkit-text-stroke: 1px black;

    &.is-visible {
        opacity: 1;
    }

    span {
        display: inline-block;
        pointer-events: none;
        ${props.decal2 &&
            `:nth-of-type(2) {
                transform: translateX(${props.decal2}%);
            }`};
    }
`

const masked = css`
    clip-path: inset(0px 100% 0px 0px);
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    transform: none;
    transition: opacity 0.2s linear, visibility 0.2s linear;
    visibility: hidden;
    will-change: clip-path;
    z-index: 4;
    -webkit-text-stroke: 1.5px white;

    &.is-visible {
        opacity: 1;
        visibility: visible;
    }
`

const imgClassFn = (props = {}) => css`
    display: block;
    height: 80vh;
    left: ${props.x}%;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: ${props.y}%;
    transform: translate(-50%, -50%) scale(0.8);
    transform-origin: center center;
    transition: opacity 0.1s linear, visibility 0.1s linear;
    visibility: hidden;
    will-change: transform, opacity, visibility;
    z-index: 1;

    &.is-visible {
        opacity: 1;
        transition: opacity 0.4s linear, visibility 0.4s linear;
        visibility: visible;
    }
`

export default Name
